import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FoundationModule } from '../foundation/foundation.module';
import { FundamentCommonModule } from '../fundament-common.module';
import { BreadcrumbItemComponent } from './breadcrumb-item/breadcrumb-item.component';
import { BreadcrumbComponent } from './breadcrumb/breadcrumb.component';
import { HyperlinkComponent } from './hyperlink/hyperlink.component';

@NgModule({
  imports: [
    CommonModule,
    FoundationModule,
    FundamentCommonModule,
    HttpClientModule,
    RouterModule,
  ],
  exports: [
    BreadcrumbComponent,
    BreadcrumbItemComponent,
    HyperlinkComponent,
    RouterModule,
  ],
  declarations: [
    BreadcrumbComponent,
    BreadcrumbItemComponent,
    HyperlinkComponent,
  ],
})
export class NavigationModule {}
